import { chakra } from '@plurall/elo-v3';

import {
  scrollTabsPanelButtonRecipe,
  scrollTabsPanelControlsRecipe,
  scrollTabsPanelListRecipe,
  scrollTabsPanelNavButtonRecipe,
  scrollTabsPanelNextRecipe,
  scrollTabsPanelPrevRecipe,
  scrollTabsPanelRootRecipe,
  scrollTabsPanelScrollableRecipe,
  scrollTabsPanelTabsRecipe,
} from './scrollTabsPanel.recipe';

export const ScrollTabsPanelRootFactory = chakra('div', scrollTabsPanelRootRecipe);
export const ScrollTabsPanelControlsFactory = chakra('div', scrollTabsPanelControlsRecipe);
export const ScrollTabsPanelPrevFactory = chakra('div', scrollTabsPanelPrevRecipe);
export const ScrollTabsPanelNextFactory = chakra('div', scrollTabsPanelNextRecipe);
export const ScrollTabsPanelNavButtonFactory = chakra('button', scrollTabsPanelNavButtonRecipe);
export const ScrollTabsPanelTabsFactory = chakra('div', scrollTabsPanelTabsRecipe);
export const ScrollTabsPanelListFactory = chakra('ul', scrollTabsPanelListRecipe);
export const ScrollTabsPanelButtonFactory = chakra('button', scrollTabsPanelButtonRecipe);
export const ScrollTabsPanelScrollableFactory = chakra('article', scrollTabsPanelScrollableRecipe);
